export const DealPresenceEvents = {
  snapshot: 'deal.presence.snapshot',
  takenOver: 'deal.lock.taken-over'
} as const;

export const DealPresenceCommands = {
  watch: 'deal.watch',
  unwatch: 'deal.unwatch',
  acquireLock: 'deal.lock.acquire',
  releaseLock: 'deal.lock.release',
  takeOverLock: 'deal.lock.take-over'
} as const;

export interface DealViewer {
  userId: string;
  displayName: string;
}

export interface DealLock {
  userId: string;
  displayName: string;
  expiresInSeconds: number;
}

export interface DealLockTakenOver {
  dealId: string;
  takenOverBy: string;
}

export interface DealPresenceSnapshot {
  dealId: string;
  viewers: DealViewer[];
  lock: DealLock | null;
}
